import type { Archive } from "../../domain/types";
import type { FeatureRoutingSettings } from "../featureRoutes";
import { settleNarrativeMemoryForTurn } from "../../features/narrative-memory/service";
import { triggerAutoEvolution } from "../../features/concurrent-evolution/service";
import { settleDeepSummaryForTurn } from "../../features/deep-summary/service";
import { settleBiographyCompression } from "../../features/concurrent-evolution/bioCompression";
export async function settleTurn(
  archive: Archive,
  input: string,
  story: string,
  route: FeatureRoutingSettings,
) {
  const memoryPromise = settleNarrativeMemoryForTurn(
    archive,
    input,
    story,
    route,
  );
  const evolution = await triggerAutoEvolution(
    archive,
    story,
    input,
    route.evolutionEnabled === false ? undefined : route,
  );
  const memory = await memoryPromise;
  const settled = {
    ...evolution.archive,
    narrativeMemory: memory.narrativeMemory,
  };
  const withBiographies = await settleBiographyCompression(settled, route);
  return settleDeepSummaryForTurn(withBiographies, route);
}
export async function runOptionalSideRequests(
  hooks: Array<() => Promise<void>> = [],
) {
  await Promise.allSettled(hooks.map((hook) => hook()));
}
